import { useSelector } from 'react-redux';
import { getImpersonatedUser } from 'js/reducers/selectors';

export function useImpersonatedUser() {
  return useSelector(getImpersonatedUser);
}
